import {useState, useRef, useEffect, useCallback, createRef} from "react";
import {FormContainer, LayoutChild} from "../../../../palette/Palette";
import HeaderPage from "../../../../palette/HeaderPage";
import VerticalSpace from "../../../../palette/VerticalSpace";
import {Filters, FilterTwo} from "../../../../utils/HelpFunctions";
import format from 'date-fns/format'
import {inject, observer} from "mobx-react";
import {Animated} from "react-animated-css";
import axios from "axios"
import DataGrid, {Editing, Export, Pager, Paging, SearchPanel, Sorting, Column} from "devextreme-react/data-grid";
import ExcelJS from "exceljs";
import {exportDataGrid} from "devextreme/excel_exporter";
import {jsPDF} from "jspdf";
import {exportDataGrid as exportDataGridToPdf} from "devextreme/pdf_exporter";
import saveAs from 'file-saver';
import {Popup} from 'devextreme-react/popup';
import OrderDetail from "./OrderDetail";
import Alerts from "../../../../palette/Alerts";

const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
};

//const url = 'http://127.0.0.1:5000/by_order';
const url = ' https://by-order-easi4xatjq-uc.a.run.app/by_order';

const useMountedState = () => {
    const mountedRef = useRef(false)
    const isMounted = useCallback(() => mountedRef.current, [])

    useEffect(() => {
        mountedRef.current = true

        return () => {
            mountedRef.current = false
        }
    }, [])

    return isMounted
}

function OrderByType(props) {

    const {DataStore, ControlStore} = props
    const {companyName, idCompany,} = DataStore
    const {routesSchedulesControl} = ControlStore

    const [load, setLoad] = useState(true)
    const [dataSource, setDataSource] = useState([])
    const [trigger, setTrigger] = useState(false)
    const [schedulesDriver, setSchedulesDriver] = useState([]);
    const [popupVisible, setPopupVisible] = useState(false);

    const isMounted = useMountedState()

    useEffect(() => {

        const GetDriverManagement = async () => {
            const data = {companyName, idCompany}
            setLoad(false)

            await axios.post(url, data, {headers: headers})
                .then(res => {
                    setLoad(true)
                    console.log(res.data)
                    setDataSource(res.data.result)
                })
        }

        if (isMounted()) {
            GetDriverManagement().catch((e) => {
                console.log(e)
                setTrigger(!trigger)
            })
        }

    }, [companyName, idCompany, isMounted, trigger])

    const dataGridRef = createRef();

    const onRowUpdating = (e) => {
        const {routeName, hour, days} = e.row.data
        const filterDay = Filters(dataSource, 'days', days)
        const result = FilterTwo(filterDay, 'hour', 'routeName', hour, routeName)
        setSchedulesDriver(result)
        setPopupVisible(true)
    }

    const onToolbarPreparing = (e) => {

        const {toolbarOptions} = e
        const {items} = toolbarOptions

        items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                width: 120,
                text: 'Imprimir',
                elementAttr: {id: 'btn-pdf'},
                icon: 'far fa-file-pdf',
                onClick: exportGridPDF
            }
        })
    }

    const onExporting = (e) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');

        exportDataGrid({
            component: e.component,
            worksheet: worksheet,
            autoFilterEnabled: true,
            topLeftCell: {row: 6, column: 2},
            customizeCell: ({gridCell, excelCell}) => {

                if (gridCell.rowType === 'data') {
                    if (excelCell.row % 2 === 0) {
                        excelCell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: {argb: 'C6EFCE'},
                            bgColor: {argb: 'C6EFCE'}
                        };
                    }
                }
            }
        }).then(function () {

            const headerCompany = worksheet.getRow(2);
            const headerReport = worksheet.getRow(3);
            const headerDate = worksheet.getRow(4);

            headerCompany.getCell(2).value = companyName;
            headerCompany.getCell(2).font = {bold: true, size: 16, underline: 'double'};

            headerReport.getCell(2).value = `Reporte : Orden de conductores`;
            headerReport.getCell(2).font = {name: 'Segoe UI Light', size: 12, bold: 600};
            headerReport.getCell(2).alignment = {horizontal: 'left'}

            headerDate.getCell(2).value = `Fecha : ${format(new Date(), 'yyyy-MM-dd')}`;
            headerDate.getCell(2).font = {name: 'Segoe UI Light', size: 8, bold: 700};
            headerDate.getCell(2).alignment = {horizontal: 'left'}

            workbook.xlsx.writeBuffer().then(function (buffer) {
                saveAs(new Blob([buffer], {type: 'application/octet-stream'}), 'Orden-conductores.xlsx');
            });
        });
        e.cancel = true;
    }

    function exportGridPDF() {
        const pdfDoc = new jsPDF();
        const dataGrid = dataGridRef.current.instance;

        const options = {
            jsPDFDocument: pdfDoc,
            component: dataGrid,
            autoTableOptions: {
                margin: {top: 35, left: 15}
            },
        }

        exportDataGridToPdf(options).then(() => {
            pdfDoc.setFontSize(12);
            const pageCount = pdfDoc.internal.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                pdfDoc.setPage(i);
                const pageSize = pdfDoc.internal.pageSize;
                const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
                const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                const header = companyName;
                const report = `Orden de conductores`
                const date = `Fecha : ${format(new Date(), 'yyyy-MM-dd')}`
                const footer = `Pagina ${i} de ${pageCount}`;

                // Header
                pdfDoc.setFontSize(14)
                pdfDoc.setFont('helvetica', '', 'bold')
                pdfDoc.text(header, 15, 10, {baseline: 'top'});
                pdfDoc.setFontSize(12)
                pdfDoc.setFont('helvetica', '', 500)
                pdfDoc.text(report, 15, 17, {baseline: 'top'});
                pdfDoc.setFontSize(8)
                pdfDoc.setFont('helvetica', '', 500)
                pdfDoc.text(date, 15, 22, {baseline: 'top'});
                // Footer
                pdfDoc.setFontSize(8)
                pdfDoc.text(footer, pageWidth / 2 - (pdfDoc.getTextWidth(footer) / 2), pageHeight - 15, {baseline: 'bottom'});

            }
        }).then(() => {
            pdfDoc.save('Orden-conductores.pdf');
        });
    }

    const buttons = [
        {
            hint: 'Ordenar conductores',
            icon: 'fas fa-user-edit',
            visible: true,
            onClick: onRowUpdating,
        },
    ]

    return (
        <>
            <VerticalSpace space={30}/>
            <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={true}>
                {routesSchedulesControl ?
                    <div className="total-grid-container">
                        <HeaderPage icon={'fas fa-sort-amount-up'} text={'Ordenar conductores'} load={load}
                                    textLoad={'Cargando....'}/>
                        <Popup
                            visible={popupVisible}
                            onHiding={() => setPopupVisible(false)}
                            dragEnabled={false}
                            closeOnOutsideClick={false}
                            showCloseButton={false}
                            showTitle={true}
                            title={`Asignar orden`}
                            width={375}
                            height={'auto'}
                        >
                            <OrderDetail schedulesDriver={schedulesDriver} setSchedulesDriver={setSchedulesDriver}
                                         setPopupVisible={setPopupVisible} idCompany={idCompany}
                                         companyName={companyName}
                                         setTrigger={setTrigger} trigger={trigger}/>
                        </Popup>
                        <FormContainer>
                            <DataGrid
                                id="order-by-type"
                                ref={dataGridRef}
                                dataSource={dataSource}
                                keyExpr="ID"
                                allowColumnReordering={true}
                                showBorders={true}
                                rowAlternationEnabled={true}
                                noDataText={'Esperando datos'}
                                onToolbarPreparing={onToolbarPreparing}
                                onExporting={onExporting}
                            >
                                <SearchPanel visible={true}
                                             width={240}
                                             placeholder="Buscar"/>
                                <Export enabled={true} texts={{exportAll: 'Excel'}}/>
                                <Sorting mode="multiple"/>
                                <Paging defaultPageSize={20}/>
                                <Pager
                                    showPageSizeSelector={true}
                                    allowedPageSizes={[10, 20, 30]}
                                    showInfo={true}/>
                                <Editing
                                    mode="row"
                                    texts={{
                                        editRow: 'Editar',
                                        deleteRow: 'Eliminar conductor',
                                    }}
                                    useIcons={true}
                                    allowUpdating={true}
                                    allowDeleting={true}
                                />
                                <Column dataField="names" alignment={'center'} caption={'Conductor'}/>
                                <Column dataField="routeName" alignment={'center'} caption={'Ruta'}/>
                                <Column dataField="days" alignment={'center'} caption={'Dia'}/>
                                <Column dataField="hour" alignment={'center'} caption={'Hora'}/>
                                <Column dataField="order" alignment={'center'} caption={'Orden'}/>
                                <Column type="buttons" width={155}
                                        buttons={buttons}/>
                            </DataGrid>
                        </FormContainer>
                    </div> :
                    <LayoutChild percent={95} margin="auto">
                        <Alerts severity="error" body={'Debe crear las rutas y horarios!'}/>
                    </LayoutChild>
                }
            </Animated>
        </>
    )
}

export default inject('DataStore', 'ControlStore')(observer(OrderByType));
